import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Rating from "react-rating";
import StartYellow from "assets/images/icon/star-yellow.svg"
import StartDefault from "assets/images/icon/star-default.svg"
import { useHistory, useLocation } from 'react-router-dom';
import { getLanguage } from '../../../../utils/params';

const RatedComponent = () => {
    const { t } = useTranslation();
    const [rating, setRating] = useState(0);
    const history = useHistory();
    const ratingApartment = JSON.parse(localStorage.getItem('ratingApartment'));
    const location = useLocation();
    const language = getLanguage(location);

    useEffect(() => {
        setRating(ratingApartment.rating)
        return function cleanup() {
            localStorage.removeItem('ratingApartment');
        };
        // eslint-disable-next-line
    }, []);

    const redirectHome = () => {
        history.push(`/${language}/`);
    };

    return (
        <>
            <div className="row">
                <div className="col-12 mt-4">
                    <h3 className="rating-title mt-5 text-center">{t('detailApartment.title_rating')}{ratingApartment.nameApartment}</h3>
                </div>
                <div className="col-12 rating">
                    <h3 className="rating-number mb-3 text-center">{rating + '.0'}</h3>
                    <div className="width-fit-content mx-auto">
                        <Rating
                            className="width-fit-content"
                            stop={5}
                            emptySymbol={<img src={StartDefault} className="icon" alt="icon-rating-default" />}
                            fullSymbol={<img src={StartYellow} className="icon" alt="icon-rating-yellow" />}
                            initialRating={rating}
                            readonly
                        />
                    </div>
                </div>
                <div className="col-12 mb-4">
                    <h3 className="rating-title mt-4 mb-3 text-center font-weight-bold">{t('detailApartment.title_review_success')}</h3>
                    <div className="text-center" dangerouslySetInnerHTML={{ __html: t('detailApartment.review_success') }}></div>
                    <div className="d-flex justify-content-center mt-5 mb-3">
                        <button type="button" onClick={redirectHome} className="button-red mb-5 btn-go-gome">{t('detailApartment.go_home')}</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RatedComponent;
